import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { legacyProjectReleasesNoteRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/legacyProjectReleasesNoteRoute.tsx';
import { classicSoftwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { LegacyFrontendReleaseNoteRedirect } from './ui/index.tsx';

export const legacyProjectReleasesNoteRouteEntry: Route = createEntry(
	legacyProjectReleasesNoteRoute,

	() => ({
		group: 'project-settings-software',
		resources: [...jiraSpaResources(), getConsolidationStateResource()],
		// eslint-disable-next-line no-restricted-syntax
		component: LegacyFrontendReleaseNoteRedirect,
		layout: classicSoftwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
